import React from "react";
import { FormattedMessage } from "react-intl";

import Alert from "components/molecules/Alert/Alert";
import PropTypes from "prop-types";

function TrackingError({ mapExpanded }) {
  const height = mapExpanded ? 566 : 250; // Height of map minus 34 pix due to overlay bar
  return (
    <>
      <div
        style={{
          position: "absolute",
          width: "100%",
          height,
          top: 0,
          left: 0,
          zIndex: 1000,
          backgroundColor: "black",
          opacity: 0.2,
        }}
      />
      <div
        className="d-flex flex-column w-100 justify-content-center align-items-center text-white font-16"
        style={{
          position: "absolute",
          top: 0,
          height,
          left: 0,
          zIndex: 1001,
        }}
      >
        <Alert variant="warning">
          <p className="m-0 d-flex flex-column">
            <FormattedMessage id="tracking.errorCoords" defaultMessage="Coordinates not yet available" />
          </p>
        </Alert>
      </div>
    </>
  );
}

TrackingError.propTypes = {
  mapExpanded: PropTypes.bool.isRequired,
};

export default TrackingError;
